import * as ToggleGroup from '@radix-ui/react-toggle-group';
import { cn } from './cn';

// Segmented control — one replacement for PillGroup, the sort pills in App.jsx,
// TabBtn in TransponderView and ModeBtn in ProfileView.
//
// Radix ToggleGroup gives keyboard behaviour those hand-rolled versions never
// had: arrow keys move between segments, Home/End jump to the ends, and only the
// active segment is in the tab order (roving tabindex) instead of all of them.

const SIZES = {
  sm: { wrap: 'p-[3px]', item: 'min-h-11 px-3 text-[14px]' },
  md: { wrap: 'p-1', item: 'min-h-11 px-3 sm:px-4 text-[15px]' },
};

export default function Segmented({
  options,
  value,
  onChange,
  size = 'md',
  ariaLabel,
  className = '',
}) {
  const s = SIZES[size] ?? SIZES.md;

  return (
    <ToggleGroup.Root
      type="single"
      value={value}
      // Radix clears the value when the active item is pressed again; keep the
      // current one so a segmented control always has exactly one selection.
      onValueChange={v => v && onChange(v)}
      aria-label={ariaLabel}
      className={cn(
        'inline-flex max-w-full flex-wrap items-center rounded-md border border-line bg-surface-3',
        s.wrap,
        className,
      )}
    >
      {options.map(opt => (
        <ToggleGroup.Item
          key={opt.value}
          value={opt.value}
          disabled={opt.disabled}
          className={cn(
            'inline-flex min-w-0 flex-1 items-center justify-center gap-1.5 rounded-sm font-display font-semibold',
            'tracking-[0.02em] whitespace-nowrap cursor-pointer transition-[background-color,color,box-shadow]',
            'duration-150 text-ink-3 hover:text-ink disabled:cursor-not-allowed disabled:opacity-45',
            'focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-primary-500',
            'data-[state=on]:bg-surface data-[state=on]:text-primary-700 data-[state=on]:shadow-e1',
            s.item,
          )}
        >
          {opt.icon}
          {opt.label}
        </ToggleGroup.Item>
      ))}
    </ToggleGroup.Root>
  );
}
